import { LANG_CULTURE } from '../appConfig';
import urlParser from '../urlParser';

const includeCustomerChat = () => {
	/**
	 * add Facebook SDK
	 */

	window.fbAsyncInit = () => {
		/* eslint-disable no-undef */
		FB.init({
			appId: 1952826854953865,
			autoLogAppEvents: true,
			xfbml: true,
			version: 'v3.2',
		});
		/**
		 * Dialog Hide
		 */
		FB.CustomerChat.hideDialog();
	};

	/**
	 * load Facebook SDK
	 */
	(function (d, s, id) {
		let js = d.getElementsByTagName(s)[0];
		const fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) return;
		js = d.createElement(s); js.id = id;
		js.src = `https://connect.facebook.net/${LANG_CULTURE[urlParser.language]}/sdk/xfbml.customerchat.js`;
		fjs.parentNode.insertBefore(js, fjs);
	}(document, 'script', 'facebook-jssdk'));
};

export default includeCustomerChat;



// WEBPACK FOOTER //
// ./src/js/common/includeCustomerChat.js